import { Link } from '../router/flashcards-fe.router-bindings'

/** A URL no route declares (flashcards-auth.spec.md `unknown-url-not-found`): say so and offer the home page. */
export function NotFoundPage() {
  return <main className="flex flex-col gap-4 p-6">
    <h1 className="text-lg font-semibold">Page not found</h1>
    <p>This address does not match any page in the app.</p>
    <Link to="/" data-testid="not-found-home" className="underline">Go to home page</Link>
  </main>
}
